import {
  CheckboxProps,
  FormControlLabel,
  Checkbox as MUICheckbox,
} from "@mui/material";
import { useApp, useTheme } from "contexts";
import React from "react";

type Props = CheckboxProps & {
  label: string;
  checked?: boolean; // controlled
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
};

export const Checkbox: React.FC<Props> = ({
  label,
  checked,
  onChange,
  ...props
}) => {
  const { t } = useApp();
  const { theme } = useTheme();

  return (
    <FormControlLabel
      label={label}
      sx={{
        "& .MuiTypography-root": {
          fontSize: theme.font.xs,
          color: theme.color.font.color,
        },
      }}
      control={
        <MUICheckbox
          name={props.name}
          checked={checked}
          onChange={onChange}
          sx={{
            color: theme.color.font.color,
            "&.Mui-checked": {
              color: theme.color.accent.color,
            },
          }}
        />
      }
    />
  );
};
